import React from "react";
import { STATUS } from "@/lib/status";

export default function StatusLegend({ className = "" }) {
  return (
    <div className={`flex flex-wrap items-center gap-x-5 gap-y-2 ${className}`} data-testid="status-legend">
      {Object.values(STATUS).map((s) => (
        <div key={s.key} className="flex items-center gap-2" data-testid={`legend-${s.key}`}>
          <span
            className="h-4 w-4 rounded-md border"
            style={{ background: s.bg, borderColor: s.border === "#E7E5E4" ? "#D6D3D1" : s.border }}
          />
          <span className="text-sm font-medium text-stone-600">{s.label}</span>
        </div>
      ))}
    </div>
  );
}
